<template>
<div>
  <div style="margin: 0 20px;font-size: 14px">
    <div style="float: left;height: 60px;width: 20%" v-if="callPhone.device_person.length > 0">
      <div style="height: 30px;color: #C0C4CC">
        <span>请选择穿戴设备号码</span>
      </div>
      <div style="height: 30px;">
        <div :class="callPhone.isDevicePerson.isOnline === 0 ? 'phone-left-gray' : 'phone-left'" @click="editCallPhone(callPhone.isDevicePerson.phone)">
          <el-row>
            <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
              <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
            </el-col>
            <el-col :span="20" style="font-size: 12px;height: 30px;">
              <div class="phone-name" :title="callPhone.isDevicePerson.personname">
                <span>
                  {{callPhone.isDevicePerson.phone}}
                  <span v-if="callPhone.isDevicePerson.personname !== ''">(</span>
                  {{callPhone.isDevicePerson.personname}}
                  <span v-if="callPhone.isDevicePerson.personname !== ''">)</span>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div :class="callPhone.isDevicePerson.isOnline === 0 ? 'select-right-gray' : 'select-right'" @click="openPhoneListShow(4)">
          <i :class="!callPhone.devicePersonShow ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
        </div>
        <div v-if="callPhone.devicePersonShow" class="phone-list">
          <div :class="item.isOnline === 0 ? 'phone-left1-gray' : 'phone-left1'"
               style="border-bottom: 1px solid #3d97f2"
               v-for="item in callPhone.device_person" :key="item.index" @click="showPhoneItem(4, item)">
            <el-row>
              <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
                <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
              </el-col>
              <el-col :span="20" style="font-size: 12px;height: 30px;">
                <div class="phone-name" :title="item.personname">
                   <span>
                  {{item.phone}}
                  <span v-if="item.personname !== ''">(</span>
                  {{item.personname}}
                  <span v-if="item.personname !== ''">)</span>
                </span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div style="float: left;height: 60px;width: 20%" v-if="callPhone.device_home.length > 0">
      <div style="height: 30px;color: #C0C4CC">
        <span>请选择家庭设备号码</span>
      </div>
      <div style="height: 30px;">
        <div :class="callPhone.isDeviceHome.isOnline === 0 ? 'phone-left-gray' : 'phone-left'" @click="editCallPhone(callPhone.isDeviceHome.phone)">
          <el-row>
            <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
              <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
            </el-col>
            <el-col :span="20" style="font-size: 12px;height: 30px;">
              <div class="phone-name" :title="callPhone.isDeviceHome.personname">
                <span>
                  {{callPhone.isDeviceHome.phone}}
                  <span v-if="callPhone.isDeviceHome.personname !== ''">(</span>
                  {{callPhone.isDeviceHome.personname}}
                  <span v-if="callPhone.isDeviceHome.personname !== ''">)</span>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div :class="callPhone.isDeviceHome.isOnline === 0 ? 'select-right-gray' : 'select-right'" @click="openPhoneListShow(3)">
          <i :class="!callPhone.deviceHomeShow ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
        </div>
        <div v-if="callPhone.deviceHomeShow" class="phone-list">
          <div  :class="item.isOnline === 0 ? 'phone-left1-gray' : 'phone-left1'"
                style="border-bottom: 1px solid #3d97f2"
               v-for="item in callPhone.device_home" :key="item.index" @click="showPhoneItem(3, item)">
            <el-row>
              <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
                <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
              </el-col>
              <el-col :span="20" style="font-size: 12px;height: 30px;">
                <div class="phone-name" :title="item.personname">
                   <span>
                  {{item.phone}}
                  <span v-if="item.personname !== ''">(</span>
                  {{item.personname}}
                  <span v-if="item.personname !== ''">)</span>
                </span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div style="float: left;height: 60px;width: 20%" v-if="callPhone.person.length > 0">
      <div style="height: 30px;color: #C0C4CC">
        <span>请选择个人号码</span>
      </div>
      <div style="height: 30px;">
        <div class="phone-left" @click="editCallPhone(callPhone.isPerson.phone)">
          <el-row>
            <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
              <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
            </el-col>
            <el-col :span="20" style="font-size: 12px;height: 30px;">
              <div class="phone-name" :title="callPhone.isPerson.personname">
                <span>
                  {{callPhone.isPerson.phone}}
                  <span v-if="callPhone.isPerson.personname !== ''">(</span>
                  {{callPhone.isPerson.personname}}
                  <span v-if="callPhone.isPerson.personname !== ''">)</span>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="select-right" @click="openPhoneListShow(1)">
          <i :class="!callPhone.personShow ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
        </div>
        <div v-if="callPhone.personShow" class="phone-list">
          <div class="phone-left1"
               style="border-bottom: 1px solid #3d97f2"
               v-for="item in callPhone.person" :key="item.index" @click="showPhoneItem(1, item)">
            <el-row>
              <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
                <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
              </el-col>
              <el-col :span="20" style="font-size: 12px;height: 30px;">
                <div class="phone-name" :title="item.personname">
                   <span>
                  {{item.phone}}
                  <span v-if="item.personname !== ''">(</span>
                  {{item.personname}}
                  <span v-if="item.personname !== ''">)</span>
                </span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div style="float: left;height: 60px;width: 20%" v-if="callPhone.home.length > 0">
      <div style="height: 30px;color: #C0C4CC">
        <span>请选择家庭号码</span>
      </div>
      <div style="height: 30px;">
        <div class="phone-left" @click="editCallPhone(callPhone.isHome.phone)">
          <el-row>
            <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
              <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
            </el-col>
            <el-col :span="20" style="font-size: 12px;height: 30px;">
              <div class="phone-name" :title="callPhone.isHome.personname">
                <span>
                  {{callPhone.isHome.phone}}
                  <span v-if="callPhone.isHome.personname !== ''">(</span>
                  {{callPhone.isHome.personname}}
                  <span v-if="callPhone.isHome.personname !== ''">)</span>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="select-right" @click="openPhoneListShow(2)">
          <i :class="!callPhone.homeShow ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
        </div>
        <div v-if="callPhone.homeShow" class="phone-list">
          <div class="phone-left1"
               style="border-bottom: 1px solid #3d97f2"
               v-for="item in callPhone.home" :key="item.index" @click="showPhoneItem(2, item)">
            <el-row>
              <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
                <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
              </el-col>
              <el-col :span="20" style="font-size: 12px;height: 30px;">
                <div class="phone-name" :title="item.personname">
                   <span>
                  {{item.phone}}
                  <span v-if="item.personname !== ''">(</span>
                  {{item.personname}}
                  <span v-if="item.personname !== ''">)</span>
                </span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div style="float: left;height: 60px;width: 20%" v-if="callPhone.familyperson.length > 0">
      <div style="height: 30px;color: #C0C4CC">
        <span>请选择紧急联系人号码</span>
      </div>
      <div style="height: 30px;">
        <div class="phone-left" @click="editCallPhone(callPhone.isFamilyPerson.phone)">
          <el-row>
            <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
              <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
            </el-col>
            <el-col :span="20" style="font-size: 12px;height: 30px;">
              <div class="phone-name" :title="callPhone.isFamilyPerson.familyperson_name">
                <span>
                  {{callPhone.isFamilyPerson.phone}}
                  <span v-if="callPhone.isFamilyPerson.personname !== ''">(</span>
                  {{callPhone.isFamilyPerson.remark}}
                  <span v-if="callPhone.isFamilyPerson.remark !== ''">:</span>
                  {{callPhone.isFamilyPerson.familyperson_name}}
<!--                  {{callPhone.isFamilyPerson.personname}}-->
                  <span v-if="callPhone.isFamilyPerson.personname !== ''">)</span>
                </span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="select-right" @click="openPhoneListShow(5)">
          <i :class="!callPhone.familyPersonShow ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"></i>
        </div>
        <div v-if="callPhone.familyPersonShow" class="phone-list">
          <div class="phone-left1"
               style="border-bottom: 1px solid #3d97f2"
               v-for="item in callPhone.familyperson" :key="item.index" @click="showPhoneItem(5, item)">
            <el-row>
              <el-col :span="4" style="text-align: right;height: 26px;line-height: 26px">
                <img src="../../../assets/phoneIcon/phone_equipment.png" style="vertical-align: middle">
              </el-col>
              <el-col :span="20" style="font-size: 12px;height: 30px;">
                <div class="phone-name" :title="item.familyperson_name">
                   <span>
                    {{item.phone}}
                    <span v-if="item.personname !== ''">(</span>
                    {{item.remark}}
                     <span v-if="item.remark !== ''">:</span>
                    {{item.familyperson_name}}
                    <span v-if="item.personname !== ''">)</span>
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both;height: 5px"></div>
  </div>
</div>
</template>

<script>
import {makePhoneCall} from '../../../sip/sip_index'
import {sendSub} from '../../../mq'

export default {
  name: 'callPhoneOut',
  props: {
    phoneOut: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      oldperson: '',
      isAlarm: '',
      callPhoneObj: {},
      callPhone: {
        device_person: [], // 穿戴设备号码
        devicePersonShow: false,
        isDevicePerson: {},
        device_home: [], // 家庭设备号码
        deviceHomeShow: false,
        isDeviceHome: {},
        person: [], // 个人号码
        personShow: false,
        isPerson: {},
        home: [], // 家庭号码
        homeShow: false,
        isHome: {},
        familyperson: [], // 紧急联系人号码
        familyPersonShow: false,
        isFamilyPerson: {}
      },
      showDate: ''
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    this.showDate = new Date().format('yyyy-MM-dd hh:mm:ss')
    this.getDataList()
  },
  methods: {
    getDataList () {
      // console.log(1234, this.phoneOut)
      this.isAlarm = this.phoneOut.isAlarm
      this.oldperson = this.phoneOut.oldperson
      this.callPhoneObj = this.phoneOut.callPhoneObj
      // 穿戴设备号码
      let arr1 = []
      for (let i = 0; i < this.phoneOut.device_person.length; i++) {
        let obj = this.phoneOut.device_person[i]
        obj.isOnline = this.getStatusName(obj)
        if (i === 0) {
          this.callPhone.isDevicePerson = obj
        }
        if (arr1.indexOf(obj.phone) === -1) {
          arr1.push(obj.phone)
          if (this.oldperson.id === obj.pid) {
            this.callPhone.device_person.unshift(obj)
          } else {
            this.callPhone.device_person.push(obj)
          }
        }
      }
      // 家庭设备号码
      let arr2 = []
      for (let i = 0; i < this.phoneOut.device_home.length; i++) {
        let obj = this.phoneOut.device_home[i]
        obj.isOnline = this.getStatusName(obj)
        if (i === 0) {
          this.callPhone.isDeviceHome = obj
        }
        if (arr2.indexOf(obj.phone) === -1) {
          arr2.push(obj.phone)
          this.callPhone.device_home.push(obj)
        }
      }
      // 个人号码
      let arr3 = []
      for (let i = 0; i < this.phoneOut.person.length; i++) {
        let obj = this.phoneOut.person[i]
        if (i === 0) {
          this.callPhone.isPerson = obj
        }
        if (arr3.indexOf(obj.phone) === -1) {
          arr3.push(obj.phone)
          if (this.oldperson.id === obj.pid) {
            this.callPhone.person.unshift(obj)
          } else {
            this.callPhone.person.push(obj)
          }
        }
      }
      // 家庭号码
      let arr4 = []
      for (let i = 0; i < this.phoneOut.home.length; i++) {
        let obj = this.phoneOut.home[i]
        if (i === 0) {
          this.callPhone.isHome = obj
        }
        if (arr4.indexOf(obj.phone) === -1) {
          arr4.push(obj.phone)
          this.callPhone.home.push(obj)
        }
      }
      // 紧急联系人号码
      let arr5 = []
      for (let i = 0; i < this.phoneOut.familyperson.length; i++) {
        let obj = this.phoneOut.familyperson[i]
        if (i === 0) {
          this.callPhone.isFamilyPerson = obj
        }
        if (arr5.indexOf(obj.phone) === -1) {
          arr5.push(obj.phone)
          this.callPhone.familyperson.push(obj)
        }
      }
      // console.log(this.callPhone)
    },
    getStatusName (item) {
      if (item.last_online === '') {
        return 0
      }
      let start = Date.parse(new Date(item.last_online))
      let end = Date.parse(new Date(this.showDate))
      // console.log(item, item.last_online, start, end)
      // 时间差
      let leftTime = end - start
      let day = 0
      let hour = 0
      let min = 0
      // console.log(leftTime)
      if (leftTime >= 0) {
        // 天
        day = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        // 时
        hour = Math.floor(leftTime / 1000 / 60 / 60 % 24)
        // 分
        min = Math.floor(leftTime / 1000 / 60 % 60)
        // 0离线、离家 1在线、在家
        // console.log(day + '天' + hour + '时' + min + '分')
        if (day > 0) {
          return 0
        } else if (hour > 0) {
          // console.log(item.phonetype, hour)
          if (item.phonetype === 1) { // 穿戴
            if (hour > 2) {
              return 0
            } else {
              return 1
            }
          } else if (item.phonetype === 2) { // 网关
            return 0
          }
        } else {
          if (item.phonetype === 1) { // 穿戴
            return 1
          } else if (item.phonetype === 2) { // 网关
            if (min <= 15) {
              return 1
            } else {
              return 0
            }
          }
        }
      }
    },
    openPhoneListShow (val) {
      // console.log(val)
      if (val === 1) { // 个人号码
        this.callPhone.personShow = !this.callPhone.personShow
        this.callPhone.homeShow = false
        this.callPhone.deviceHomeShow = false
        this.callPhone.devicePersonShow = false
        this.callPhone.familyPersonShow = false
      } else if (val === 2) { // 家庭号码
        this.callPhone.homeShow = !this.callPhone.homeShow
        this.callPhone.personShow = false
        this.callPhone.deviceHomeShow = false
        this.callPhone.devicePersonShow = false
        this.callPhone.familyPersonShow = false
      } else if (val === 3) { // 家庭设备号码
        this.callPhone.deviceHomeShow = !this.callPhone.deviceHomeShow
        this.callPhone.personShow = false
        this.callPhone.homeShow = false
        this.callPhone.devicePersonShow = false
        this.callPhone.familyPersonShow = false
      } else if (val === 4) { // 穿戴设备号码
        this.callPhone.devicePersonShow = !this.callPhone.devicePersonShow
        this.callPhone.personShow = false
        this.callPhone.homeShow = false
        this.callPhone.deviceHomeShow = false
        this.callPhone.familyPersonShow = false
      } else if (val === 5) { // 紧急联系人号码
        this.callPhone.familyPersonShow = !this.callPhone.familyPersonShow
        this.callPhone.personShow = false
        this.callPhone.homeShow = false
        this.callPhone.deviceHomeShow = false
        this.callPhone.devicePersonShow = false
      }
    },
    showPhoneItem (val, obj) {
      if (val === 1) {
        this.callPhone.isPerson = obj
      } else if (val === 2) {
        this.callPhone.isHome = obj
      } else if (val === 3) {
        this.callPhone.isDeviceHome = obj
      } else if (val === 4) {
        this.callPhone.isDevicePerson = obj
      } else if (val === 5) {
        this.callPhone.isFamilyPerson = obj
      }
    },
    editCallPhone (phoneNum) {
      if (phoneNum.slice(0, 3) === '021') {
        return
      }
      if (!this.isAlarm) { // 客服关爱
        let obj = {
          type: 'call',
          phoneNum: phoneNum
        }
        this.$emit('fatherEvent', obj)
        let name = this.$store.state.user.personname
        // eslint-disable-next-line no-extend-native
        Date.prototype.format = this.validate.format
        const date = new Date().format('hh:mm:ss')
        let doCall = {id: this.callPhoneObj.id, name: name, time: date}
        let mqtts = this.$store.state.user.mqtts
        sendSub('callphone' + mqtts[0], JSON.stringify(doCall))
      }
      makePhoneCall(phoneNum)
      this.$notify({
        title: '成功',
        message: '正在呼叫，请注意接听电话，用以呼叫',
        type: 'success',
        duration: 1000
      })
    }
  }
}
</script>

<style scoped>
  .phone-left{
    font-size: 11px;
    cursor: pointer;
    width: 200px;
    height: 28px;
    line-height: 28px;
    background-image: linear-gradient(0deg,
    #1684fc 0%,
    #66b2ff 100%);
    border-radius: 6px;
    color: white;
    float: left;
  }
  .phone-left-gray{
    font-size: 11px;
    cursor: pointer;
    width: 200px;
    height: 28px;
    line-height: 28px;
    background-image: linear-gradient(0deg,
    #98999a 0%,
    #cdcfcf 100%);
    border-radius: 6px;
    color: white;
    float: left;
  }
  .phone-left img {
    width: 20px;
    height: 11px;
  }
  .phone-left1{
    font-size: 11px;
    cursor: pointer;
    width: 200px;
    height: 28px;
    line-height: 28px;
    background-color: #61aaf2;
    color: white;
    float: left;
  }
  .phone-left1 img {
    width: 20px;
    height: 11px;
  }
  .phone-left1-gray{
    font-size: 11px;
    cursor: pointer;
    width: 200px;
    height: 28px;
    line-height: 28px;
    background-color: #cdcfcf;
    color: white;
    float: left;
  }
  .phone-left1-gray img {
    width: 20px;
    height: 11px;
  }
  .select-right-gray{
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    width: 28px;
    height: 28px;
    line-height: 28px;
    background-image: linear-gradient(0deg,
    #98999a 0%,
    #cdcfcf 100%);
    border-radius: 6px;
    color: white;
    float: left;
  }
  .select-right{
    text-align: center;
    font-size: 18px;
    cursor: pointer;
    width: 28px;
    height: 28px;
    line-height: 28px;
    background-image: linear-gradient(0deg,
    #1684fc 0%,
    #66b2ff 100%);
    border-radius: 6px;
    color: white;
    float: left;
  }
  .phone-name{
    float: left;
    width: 100%;
    height: 28px;
    line-height: 28px;
    display:block;
    overflow:hidden;
    word-break:keep-all;
    white-space:nowrap;
    text-overflow:ellipsis;
  }
  .phone-list{
    overflow: hidden;
    z-index: 999999;
    position: relative;
    width: 200px;
    height: 200px;
    overflow-y: auto;
    top: 3px;
    /*background-color: #00aaff;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/handlealarm/childComponents/callPhoneOut.vue